import { useMutation } from "@tanstack/react-query";
import { createAxiosWithAuth } from "./middleware";

export const useSetArticleAnswers = () => {
  const axios = createAxiosWithAuth();

  return useMutation({
    mutationKey: ["institute-answer"],
    mutationFn: async (query) => {
      const res = await axios.post("/institute/answer", query);
      return res.data;
    },
  });
};